import { inject } from "@angular/core";
import { StorageService } from "./auth-storage.service"

export class AuthStorage {
    private storageService = inject(StorageService);

    public getItem(key: string) {
        return this.storageService?.getItem(key);
    }

    public removeItem(key: string) {
        this.storageService.removeItem(key);
    }

    public setItem(key: string, value: any) {
        this.storageService?.setItem(key, value);
    }
}